<template>
  <div
    id="app"
    class="container"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
    <toast />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {

  },
  mounted() {
    document.addEventListener('click', this.handleClick);

    // Theme Color Changing
    this.$store.dispatch('common/themeHandler');
  },
  destroyed() {
    document.removeEventListener('click', this.handleClick);
  },
  methods: {
    handleClick(e) {
      const element = e.target;
      const dropdown = element.closest('div.dropdown');
      const openedDropdowns = document.querySelectorAll('.dropdown.is-active');

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < openedDropdowns.length; i++) {
        const targetDropdown = openedDropdowns[i];

        if (targetDropdown) {
          targetDropdown.classList.remove('is-active');
        }
      }
      if (dropdown && !dropdown.classList.contains('is-active')) {
        dropdown.classList.add('is-active');
      }
    }
  }
};
</script>
